import sendRequest from "./send-request";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function toQueryString(params = {}) {
  const query =
    params instanceof URLSearchParams
      ? params.toString()
      : new URLSearchParams(params).toString();
  return query ? `?${query}` : "";
}

export async function index(params = {}) {
  return sendRequest(`${BASE_URL}/items${toQueryString(params)}`, "GET");
}

export async function featured() {
  return sendRequest(`${BASE_URL}/items/featured`, "GET");
}

export async function stats() {
  return sendRequest(`${BASE_URL}/items/stats`, "GET");
}

export async function hiddenIndex(params = {}) {
  return sendRequest(`${BASE_URL}/items/hidden${toQueryString(params)}`, "GET");
}

export async function create(data) {
  return sendRequest(`${BASE_URL}/items`, "POST", data);
}

export async function detail(catalogueId) {
  return sendRequest(`${BASE_URL}/items/${catalogueId}`, "GET");
}

export async function destroy(id) {
  return sendRequest(`${BASE_URL}/items/${id}`, "DELETE");
}

export async function update(id, data) {
  return sendRequest(`${BASE_URL}/items/${id}`, "PUT", data);
}

export async function getS3Url(contentType) {
  const query = contentType
    ? `?contentType=${encodeURIComponent(contentType)}`
    : "";
  return sendRequest(`${BASE_URL}/s3urls${query}`, "GET");
}

export async function sendS3Url(url, file) {
  try {
    const contentType = file.type || "image/png";
    await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": contentType,
      },
      body: file,
    });
    return url.split("?")[0];
  } catch (err) {
    console.log(err);
    return err;
  }
}
